export default "__VITE_ASSET__B1VQlV$f__"